import { cx } from '@platform/core/lib/cx';
import type { IObserverRowProps } from './IObserverRowProps';

/**
 * Рядок особи (прототип v4 obsUsers): кружок ініціалів, ім'я та e-mail, праворуч «фракція · комітет» до двох рядків із повним текстом у
 * підказці. Поки відкривається сесія (перше відкриття створює демо-офіс — кілька секунд), обраний рядок підсвічено, решта притушено.
 */
export function ObserverRow({ person, busy, picked, onPick }: IObserverRowProps) {
  return (
    <button type="button" className={cx('obs-row', picked && 'is-picked')} disabled={busy} aria-busy={picked || undefined} onClick={() => onPick(person.id)}>
      <span className="obs-ini" aria-hidden="true">{person.initials}</span>
      <span className="obs-who"><strong className="obs-name">{person.name}</strong><span className="obs-email">{person.email ?? ''}</span></span>
      <span className="obs-meta" title={person.meta}>{person.meta}</span>
    </button>
  );
}
